<script>
import {HorizontalBar} from "vue-chartjs";

export default {
  name: "PolarityGraph",
  extends: HorizontalBar,
  props: {
    company: {},
  },
  methods: {
    renderPolarityChart: function () {
      let options = {
        events: [],
        scales: {
          yAxes: [
            {
              barThickness: 20,
              gridLines: {
                offsetGridLines: true,
              },
            },
          ],
          xAxes: [
            {
              display: false,
            },
          ],
        },
        animation: {
          easing: "easeInQuint",
          onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
            ctx.font = "16px Gotham";
            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";

            this.data.datasets.forEach(function (dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                var data = dataset.data[index];
                ctx.fillText(data, bar._model.x - 10, bar._model.y + 9);
              });
            });
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      };

      let data = {
        labels: ["Totaal", "Neutraal", "Positief", "Negatief"],
        datasets: [
          {
            label: "Geurbelevingen",
            backgroundColor: [
              "rgb(79,79,79)",
              "rgb(179,179,179)",
              "rgb(22, 205, 190, 1)",
              "rgba(151, 50, 77, 1)",
            ],
            data: [
              this.company.totalReviews,
              this.company.neutralReviews,
              this.company.positiveReviews,
              this.company.negativeReviews,
              0,
            ],
          },
        ],
      };
      this.renderChart(data, options);
    },
  },
  mounted() {
    this.renderPolarityChart();
  },
  watch: {
    company: function () {
      this.renderPolarityChart();
    },
  },
};
</script>
